import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgPhone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M25 19.375c0 .281-.052.648-.156 1.102-.104.453-.214.81-.328 1.07-.22.52-.854 1.073-1.907 1.656-.979.531-1.948.797-2.906.797-.281 0-.557-.018-.828-.055a6.404 6.404 0 0 1-.898-.195c-.329-.094-.573-.17-.735-.227-.161-.057-.45-.164-.867-.32s-.672-.25-.766-.281a14.151 14.151 0 0 1-2.734-1.297c-1.323-.823-2.698-1.948-4.125-3.375s-2.552-2.802-3.375-4.125a14.15 14.15 0 0 1-1.297-2.734 33.446 33.446 0 0 0-.281-.766 61.557 61.557 0 0 1-.32-.867 13.4 13.4 0 0 1-.227-.735 6.42 6.42 0 0 1-.195-.898A6.2 6.2 0 0 1 3 7.297c0-.958.266-1.927.797-2.906.583-1.052 1.135-1.688 1.656-1.907.26-.114.617-.224 1.07-.328.454-.104.82-.156 1.102-.156.146 0 .255.016.328.047.188.062.464.458.828 1.187.115.198.271.48.469.844.198.365.38.695.547.992.167.297.328.576.484.836.031.042.123.172.274.39.15.22.263.405.336.556.072.15.109.299.109.445 0 .208-.148.469-.445.781-.297.313-.62.6-.97.86a9.41 9.41 0 0 0-.968.828c-.297.291-.445.53-.445.718 0 .094.026.211.078.352.052.14.096.247.133.32.036.073.11.198.219.375s.169.276.18.297c.79 1.427 1.697 2.651 2.718 3.672 1.02 1.02 2.245 1.927 3.672 2.719.02.01.12.07.297.18.177.109.302.182.375.218.073.037.18.08.32.133.14.052.258.078.352.078.187 0 .427-.148.718-.445.292-.297.568-.62.828-.969s.547-.672.86-.969c.312-.297.573-.445.781-.445.146 0 .294.037.445.11.151.072.336.184.555.335.219.151.35.242.39.274.261.156.54.317.837.484.297.167.627.35.992.547.364.198.646.354.844.469.729.364 1.125.64 1.187.828a.874.874 0 0 1 .047.328z" />
  </svg>
);
export default SvgPhone;
